import React from "react";
import {
  CardBody,
  Row,
  Col,
  ModalBody,
} from "reactstrap";
// import { history } from '_helpers';

// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";

import { feeActions } from '_actions';

import { currencyFormat } from '_helpers';

class TicketsHelpModal extends React.Component {
  constructor(props) {
    super(props);
    console.log("CreateUpdateLocation constructor()", props)
    this.state = {
    };
  }



  componentDidMount() {
  }

  render() {
    const { fees, fetchingFees } = this.props
    const { liveNyteTicketPercentage, liveNyteTicketFlatFee, stripeFlatFee, stripePercentage, liveNyteBookingPercentage, liveNyteBookingHandlingFee, } = fees
    console.log("fees", fees)
    // let remit = num * ticket.price
    // let lvFee = remit * (liveNyteTicketPercentage/100) +
    //             num   * liveNyteTicketFlatFee
    // let stripeFee = (remit + lvFee + stripeFlatFee) / (1 - (stripePercentage/100)) - remit - lvFee
    // console.log("num", num, "remit", remit, "lvFee", lvFee, "stripeFee", stripeFee)
    console.log("TicketsHelpModal: render", this.state)


    if (fetchingFees) {
      return (
        <div>Loading</div>
      )
    }
    return (
      <ModalBody>
        <Row>
          <Col xs={12}>
            <p className="text-left px-2 py-2">
              <h3 className="text-uppercase mb-1">General</h3>
              <div className="title mb-2 text-muted">
                Create tickets to sell to event attendees.
              </div>

              <ul className="modal-list">
                <li>
                  You can create multiple ticket types and specify details such as price, description, quantity, ticket sale duration, and purchase limits.
                </li>
                <li>
                  Your check-in staff can use the <i>LiveNyte: Event Manager</i> app to scan QR codes with their phone's camera for guest check-ins.
                </li>
                <li>
                  Event staff can log in to the app using your event's ID (assigned by LiveNyte) and manager app password (which you can set or update by tapping the update button) to check in guests.
                </li>
              </ul>

              <h3 className="text-uppercase mb-1">Payout & Fees</h3>
              <ul className="modal-list">
                <li>
                  Ticket sale revenue is usually scheduled to deposit into your connected bank account 3 days after your event.
                </li>
                <li>
                  LiveNyte collects a fee of {liveNyteTicketPercentage}% + {currencyFormat('us', liveNyteTicketFlatFee)} per transaction from the ticket purchaser.
                  The payment processor also collects {stripePercentage}% + {currencyFormat('us', stripeFlatFee)} per transaction. LiveNyte reserves the right to change these fees in the future.
                </li>
                <li>
                  Each U.S. state has different laws regarding sales tax. If you're unsure whether tax applies to your ticket sales, consult a tax professional. LiveNyte cannot provide tax advice.
                </li>
                <li>
                  LiveNyte does not automatically add tax to ticket prices. You are responsible for paying any required taxes on the ticket revenue you receive to the appropriate authorities.
                </li>
              </ul>
            </p>
          </Col>
        </Row>
      </ModalBody>
    );
  }
}

function mapStateToProps(state) {
  const { feesData } = state;
  const { fees, fetchingFees } = feesData;
  return {
    fees, fetchingFees
  };
}

const connectedTicketsHelpModal = connect(mapStateToProps)(TicketsHelpModal);
export { connectedTicketsHelpModal as TicketsHelpModal }; 